import { render, staticRenderFns } from "./Indents.vue?vue&type=template&id=0647278a&scoped=true"
import script from "./Indents.vue?vue&type=script&lang=js"
export * from "./Indents.vue?vue&type=script&lang=js"
import style0 from "./Indents.vue?vue&type=style&index=0&id=0647278a&prod&lang=css"
import style1 from "./Indents.vue?vue&type=style&index=1&id=0647278a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0647278a",
  null
  
)

export default component.exports